import GitHub from './GitHub';

export default GitHub;
export * from './GitHub';
